import { Controller } from "stimulus";
import consumer from "channels/consumer";
import { percent, countdown } from "utils/live_poll";

const STRUCTURAL_ACTIONS = ["sync", "open", "awaiting", "resolved", "closed", "cancelled"];

// Drives the creator dashboard "Polls" column: patches tallies in place and reloads the
// live_polls_column Turbo Frame on structural poll events from the LiveStreamChannel.
export default class LivePollDashboard extends Controller {
  static values = { liveEventId: Number };

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "LiveStreamChannel", context_type: "live_event", context_id: this.liveEventIdValue },
      { received: this.received.bind(this) }
    );

    this.startCountdownTicker();
  }

  disconnect() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription);
      this.subscription = null;
    }
    if (this.ticker) {
      window.clearInterval(this.ticker);
      this.ticker = null;
    }
  }

  received(data) {
    if (!data || data.type !== "poll") return;

    if (data.action === "tally") {
      this.applyTally(data.poll);
    } else if (STRUCTURAL_ACTIONS.includes(data.action)) {
      this.reloadColumn();
    }
  }

  // The frame keeps its src, so reload() re-fetches the server-rendered column state.
  reloadColumn() {
    const frame = document.getElementById("live_polls_column");
    if (frame && typeof frame.reload === "function") frame.reload();
  }

  applyTally(poll) {
    if (!poll) return;

    const panel = this.element.querySelector(`[data-poll-id="${poll.id}"]`);
    if (!panel) return;
    // Ignore a late tally once the panel is no longer the open/voting state - the structural
    // reload already rendered the final counts. The countdown only exists while open.
    if (!panel.querySelector("[data-live-poll-dashboard-target='countdown']")) return;

    const total = Number(poll.total_votes) || 0;
    const totalEl = panel.querySelector("[data-live-poll-dashboard-target='total']");
    if (totalEl) totalEl.textContent = total;

    (poll.options || []).forEach((option) => {
      const row = panel.querySelector(`[data-option-id="${option.id}"]`);
      if (!row) return;

      const count = Number(option.count) || 0;
      const pct = percent(count, total);

      const countEl = row.querySelector("[data-live-poll-dashboard-target='count']");
      const percentEl = row.querySelector("[data-live-poll-dashboard-target='percent']");
      const barEl = row.querySelector("[data-live-poll-dashboard-target='bar']");

      if (countEl) countEl.textContent = count;
      if (percentEl) percentEl.textContent = `${pct}%`;
      if (barEl) barEl.style.width = `${pct}%`;
    });
  }

  // Ticks the "closes in M:SS" indicator each second from its data-closes-at timestamp.
  startCountdownTicker() {
    this.ticker = window.setInterval(() => this.tickCountdown(), 1000);
    this.tickCountdown();
  }

  tickCountdown() {
    const el = this.element.querySelector("[data-live-poll-dashboard-target='countdown']");
    if (!el) return;

    const result = countdown(el.dataset.closesAt);
    if (result) el.textContent = result.label;
  }
}
